import { useState, useEffect } from 'react';
import { OnboardingChecklistService } from './onboardingChecklistService';
import { useCurrentUser } from 'src/store/user';


export const useOnboardingChecklist = (organizationSlug?: string) => {
  const [isVisible, setIsVisible] = useState(false);
  const [hasCompletedOnboarding, setHasCompletedOnboarding] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  
  // Get current user to check if joyride onboarding is completed
  const { currentUser } = useCurrentUser();

  useEffect(() => {
    const checkOnboardingStatus = async () => {
      if (!organizationSlug) {
        setHasCompletedOnboarding(false);
        setIsVisible(false); // Don't show checklist without organizationSlug
        return;
      }      
      // Check if joyride onboarding tour has been completed
      if (!currentUser || !currentUser.is_product_tour_complete) {
        // Don't show checklist until joyride onboarding is completed
        setHasCompletedOnboarding(false);
        setIsVisible(false);
        return;
      }
      
      try {
        setIsLoading(true);
        const progress = await OnboardingChecklistService.getProgress(organizationSlug);
        
        const allCompleted = progress.all_completed;
        const shouldShow = progress.should_show_checklist;
        
        setHasCompletedOnboarding(allCompleted);
        // Only show checklist if both joyride is completed AND backend says it should show
        setIsVisible(shouldShow);
        
      } catch (error) {
        console.error('Failed to check onboarding status:', error);
        setHasCompletedOnboarding(false);
        setIsVisible(false); // Don't show checklist on error without organizationSlug
      } finally {
        setIsLoading(false);
      }
    };

    checkOnboardingStatus();
  }, [organizationSlug, currentUser]);

  const showChecklist = () => {
    // Only allow showing checklist if joyride onboarding is completed
    if (currentUser && currentUser.is_product_tour_complete) {
      setIsVisible(true);
    }
  };

  const hideChecklist = () => {
    setIsVisible(false);
  };

  const completeOnboarding = () => {
    setHasCompletedOnboarding(true);
    setIsVisible(false);
  };

  const resetOnboarding = () => {
    // Only allow resetting onboarding if joyride onboarding is completed
    if (currentUser && currentUser.is_product_tour_complete) {
      setHasCompletedOnboarding(false);
      setIsVisible(true);
    }
  };

  return {
    isVisible,
    hasCompletedOnboarding,
    isLoading,
    showChecklist,
    hideChecklist,
    completeOnboarding,
    resetOnboarding
  };
};
